__turbopack_context__.v({
  "Switch": "EditContactForm-module-scss-module__4FaHwW__Switch",
  "Thumb": "EditContactForm-module-scss-module__4FaHwW__Thumb",
  "body": "EditContactForm-module-scss-module__4FaHwW__body",
  "center": "EditContactForm-module-scss-module__4FaHwW__center",
  "editEmailBtn": "EditContactForm-module-scss-module__4FaHwW__editEmailBtn",
  "row": "EditContactForm-module-scss-module__4FaHwW__row",
  "separator": "EditContactForm-module-scss-module__4FaHwW__separator",
  "switchDesc": "EditContactForm-module-scss-module__4FaHwW__switchDesc",
  "switchLabel": "EditContactForm-module-scss-module__4FaHwW__switchLabel",
  "switchLabelWrapper": "EditContactForm-module-scss-module__4FaHwW__switchLabelWrapper",
});
